var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBetaBadge)?_c('div',{staticClass:"cz2__ai-modal-beta",class:{ 'cz2__in-button': _vm.isInButton },attrs:{"role":"status"}},[_vm._v(" "+_vm._s(_vm.$t('AI_BETA'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }